export const ONBOARDING_BASE_PATHS = {
  pi: "pi-onboarding",
  loan: "loan-application",
};

export const ONBOARDING_SESSION_TYPE_ID = {
  piOnboarding: 1,
  loanApplication: 3,
};

export const ROUTES = {
  identification: "identification",
  privateInformation: "private-information",
  aboutServices: "about-services",
};

export const ROUTES_TRANSLATIONS_KEYS = {
  [ROUTES.identification]: "identification_header",
  [ROUTES.aboutServices]: "about_services_header",
  [ROUTES.privateInformation]: "private_information_header",
};

export const ROUTES_IDS = {
  [ROUTES.identification]: 1,
  [ROUTES.aboutServices]: 3,
  [ROUTES.privateInformation]: 2,
};

export const NAVBAR_ITEMS = [
  {
    id: ROUTES_IDS[ROUTES.identification],
    name: ROUTES.identification,
    translationKey: ROUTES_TRANSLATIONS_KEYS[ROUTES.identification],
  },
  {
    id: ROUTES_IDS[ROUTES.privateInformation],
    name: ROUTES.privateInformation,
    translationKey: ROUTES_TRANSLATIONS_KEYS[ROUTES.privateInformation],
  },
  {
    id: ROUTES_IDS[ROUTES.aboutServices],
    name: ROUTES.aboutServices,
    translationKey: ROUTES_TRANSLATIONS_KEYS[ROUTES.aboutServices],
  },
];
